import React from "react";
import '../styles/main.css';
import crossIcon from "../assets/bross.png"
import Gift from "../assets/gift.png"
import { useNavigate } from "react-router-dom";
import mixpanel from 'mixpanel-browser';
import { useEffect } from "react";
import { useMixpanel } from '../context/MixpanelContext'; 

const RewardPopup = ({ onClose, coins }) => {
  const { mixpanelUserId } = useMixpanel();
    const navigate = useNavigate();
    useEffect(() => {
      if (mixpanelUserId) {
        mixpanel.identify(mixpanelUserId);
      }
      mixpanel.track("perp_milestone_popup", {
        "Properties": "displayed",
      });
    }, []);

  return (
    <div className="reward-popup-overlay">
      <div className="reward-popup">
      <button className="reward-popup-close" onClick={onClose}>
  <img width={21} height={21} src={crossIcon} alt="close icon" />
</button>
        
        <img
          src={Gift}
          alt="Gift"
          className="reward-popup-img"
        />
        <h2 className="reward-popup-title">Congratulations!</h2>
        <p className="reward-popup-subtitle">
          Your referrals completed 25 disbursals
        </p>
        <h3 className="reward-popup-amount">₹{coins || 0}</h3>
        <p className="reward-popup-text">credited to your account</p>
        <button
  onClick={() => {
    if (mixpanelUserId) {
      mixpanel.identify(mixpanelUserId);
    }
    mixpanel.track("perp_milestone_popup", {
      Properties: "clicked",
    });
    navigate("/view-all-transactions");
  }}
  className="reward-popup-btn"
>
  View My Rewards
</button>

      </div>
    </div>
  );
};

export default RewardPopup;
